import axios from 'axios';
import useSessionUser from '../hooks/useSessionUser';

export function setAuthHeader(token: string): void {
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  }
}

export const addAuthAxiosHeader = (): void => {
  const { user: auth } = useSessionUser();
  if (auth) {
    setAuthHeader(auth.access_token);
  }
};
